//@ts-nocheck
"use client";
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { FormatDate } from '../../utils/date-formatter';
import Description from '../atoms/description';
import styles from './main-content.module.css';
import Socials from '../atoms/social';
import Link from 'next/link';
import HubSpotForm from '../atoms/hub-spot-form';
import Slider from '../atoms/slider';

export default function MainContent({ data }) {

    // useEffect(() => {
    //     console.log("MainContent data:", data);
    // }, [data]);

    const [paddingTop, setPaddingTop] = useState(0);
    const [initialTop, setInitialTop] = useState(0);
    const [maxScrollHeight, setMaxScrollHeight] = useState(0);
    const stickyThreshold = 112; // 7rem in px
    const [isMobile, setIsMobile] = useState(false);

    const tagContainerRef = useRef(null);
    const [showAllTags, setShowAllTags] = useState(false);
    const [shouldShowToggle, setShouldShowToggle] = useState(false);
    const [maxRowsToShow] = useState(2); // You can tweak this
    const [shareUrl, setShareUrl] = useState("");

    const checkScreenSize = () => {
        if (typeof window === "undefined") return;
        setIsMobile(window.innerWidth <= 768);
    };

    useEffect(() => {
        checkScreenSize();

        if (typeof window === "undefined") return;
        // SSR-safe: window only exists in the browser.
        setShareUrl(encodeURIComponent(window.location.href));

        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // useEffect(() => {
    //     const contentDetails = document.querySelector(`.${styles['content-details']}`);
    //     const description = document.querySelector(`.${styles['description']}`);

    //     if (!contentDetails || !description) return;

    //     setInitialTop(contentDetails.getBoundingClientRect().top + window.scrollY);

    //     const contentHeight = contentDetails.offsetHeight;
    //     const descriptionBottom = description.getBoundingClientRect().bottom + window.scrollY;
    //     setMaxScrollHeight(descriptionBottom - contentHeight);

    //     const handleScroll = () => {
    //         if (!isMobile) {
    //             const scrollY = window.scrollY || document.documentElement.scrollTop;
    //             const distanceFromTop = initialTop - scrollY;
    
    //             if (distanceFromTop <= stickyThreshold) {
    //                 const newPaddingTop = Math.max(0, stickyThreshold - distanceFromTop);
    //                 const maxAllowedPadding = maxScrollHeight - initialTop;
    //                 setPaddingTop(Math.min(newPaddingTop, maxAllowedPadding));
    //             } else {
    //                 setPaddingTop(0);
    //             }
    //         }
    //     };
    //     window.addEventListener('scroll', handleScroll);
    //     return () => window.removeEventListener('scroll', handleScroll);
    // }, [initialTop, maxScrollHeight]);

    const words = data.mainContent?.split(/\s+/).length || 0;
    const readingSpeed = 250; // Words per minute (WPM)
    const minutes = words / readingSpeed;

    let readingTime;
    if (minutes < 1) {
        readingTime = 'less than a minute.';
    } else {
        readingTime = `${Math.ceil(minutes)} minute${Math.ceil(minutes) === 1 ? '' : 's'}`;
    }

    const url = shareUrl;

    // Normalize tags defensively: interpreter should always return arrays,
    // but legacy / uninterpreted payloads may carry undefined or Strapi shapes.
    const toTagList = (rel) => {
        const arr = Array.isArray(rel) ? rel : rel?.data;
        if (!Array.isArray(arr)) return [];
        return arr
            .map((item) => item?.attributes?.title ?? item?.title ?? (typeof item === "string" ? item : item))
            .filter((t) => typeof t === "string" && t.length > 0);
    };
    const industries = toTagList(data?.industries);
    const solutions = toTagList(data?.solutions);
    const allTags = [
        ...industries.map(tag => ({ type: "Industry", tag })),
        ...solutions.map(tag => ({ type: "Solutions", tag })),
    ];

    useEffect(() => {
        const container = tagContainerRef.current;
        if (!container) return;
    
        const children = Array.from(container.children);
        const rows = new Set(children.map(child => child.offsetTop));
        
        if (rows.size > maxRowsToShow) {
            setShouldShowToggle(true);
        }
    }, [data?.industries, data?.solutions]);

    return (
        <div className={styles['content-wrapper']}>
            <div className={styles['description']}>
                {/* Add this class to track the bottom */}
                <Description description={data.mainContent} mode="blog" />
            </div>

            {/* Content-details with dynamic padding on scroll */}
            <div
                className={clsx(styles['content-details'])}
                // style={{
                //     paddingTop: `${paddingTop}px`,
                //     transition: 'padding-top 0.1s ease-out',
                // }}
            >
                <div className={styles["hub-form"]}>
                    <HubSpotForm hubSpotCredentials={{
                        portalId: "6864149",
                        formId: "34afe99e-75b9-4653-98be-2a7bd849f57c",
                        region: "na1"
                    }}/>
                </div>
                {data?.readingTime !== false && <div>
                    Reading Time
                    <div className="sectionName" title={`${readingSpeed} WPM`}>
                        {readingTime}
                    </div>
                </div>}
                {data.datePublished && <div>
                    Date Posted
                    <div className="sectionName">{FormatDate(data.datePublished)}</div>
                </div>}
                {data.authorFullName && (
                    <div>
                        Author
                        <div className={styles['author-details']}>
                            {data.authorImage ? (
                                <div
                                    className={styles['author-img']}
                                    style={{ borderRadius: '999999px' }}
                                >
                                    {/* <img src={data.authorImage} alt="Author" /> */}
                                    <Slider imageList={[data.authorImage]}/>
                                </div>
                            ) : (
                                <div
                                    className={styles['author-img']}
                                    style={{ borderRadius: 0 }}
                                >
                                    <img
                                        src="/VXI-SVG.svg"
                                        alt="Author"
                                        style={{ borderRadius: 0, fill: '#FF6D10' }}
                                    />
                                </div>
                            )}
                            <div className="sectionName">
                                <a 
                                    // href={`/what-we-think?Author=${data.authorFullName.replace(/ /g, "+").replace(/&/g, "%26")}`}
                                    href={
                                    data.authorFullName === "VXI"
                                        ? "/what-we-think"
                                        : `/what-we-think?Author=${data.authorFullName.replace(/ /g, "+").replace(/&/g, "%26")}`
                                    }
                                    rel="noopener noreferrer"
                                >
                                    <b><u>{data.authorFullName}</u></b>
                                </a>
                                {data.authorTitle && <div>{data.authorTitle}</div>}
                                {data.authorLink && <Socials attr={{ socialTypes: 'linkedin', socialLink: data.authorLink }} />}
                            </div>
                        </div>
                    </div>
                )}
                {(allTags.length > 0) && (
                    <div>
                        Tags
                        <div
                            className={clsx(styles['author-tag'], 
                                // {[styles['clamp-tags']]: !showAllTags && shouldShowToggle}
                        )}
                            ref={tagContainerRef}
                        >
                            {allTags
                                .map((item, index) => (
                                    <Link 
                                        key={index}
                                        href={`/what-we-think?${item.type}=${item.tag.replace(/ /g, "+").replace(/&/g, "%26")}`}
                                        legacyBehavior
                                    >
                                        <a
                                            className={clsx('sectionName', styles.tag)}
                                        >
                                            {item.tag}
                                        </a>
                                    </Link>
                            ))}
                        </div>

                        {/* {shouldShowToggle && (
                            <button
                                className={styles['toggle-tags']}
                                onClick={() => setShowAllTags(prev => !prev)}
                            >
                                {showAllTags ? 'Show Less' : 'Show More'}
                            </button>
                        )} */}
                    </div>
                )}
                <div>
                    Share
                    <div className={styles.socials}>
                        <Socials attr={{ socialTypes: 'X', socialLink: `https://twitter.com/intent/tweet?url=${url}` }}/>
                        {/* <Socials attr={{ socialTypes: 'youtube', socialLink: 'https://vxi.com' }} /> */}
                        <Socials attr={{ socialTypes: 'linkedin', socialLink: `https://www.linkedin.com/shareArticle?mini=true&url=${url}` }} />
                        <Socials attr={{ socialTypes: 'facebook', socialLink: `https://www.facebook.com/sharer/sharer.php?u=${url}` }} />
                    </div>
                </div>
            </div>
        </div>
    );
}
